"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const client_1 = require("@apollo/client");
// need to update this mutation to delete userProfiles
const mutation = (0, client_1.gql) `
  mutation deleteUnverifiedUser($userId: String, $email: String, $phoneNumber: String) {
    deleteUnverifiedUser(userId: $userId, email: $email, phoneNumber: $phoneNumber)
  }
`;
exports.default = mutation;
//# sourceMappingURL=deleteUnverifiedUser.mutation.js.map